import { EditOutlined } from '@ant-design/icons';
import Text from 'antd/es/typography/Text';
import { When } from 'react-if';
import React, { useCallback, useEffect, useState } from 'react';
import { useCurrentUser, useUpdateOrganization } from '@hooks';
export const OrganizationNameInput = ({ organizationId, organizationName }) => {
    const [sentOrganizationNamePatchRequest, setSentOrganizationNamePatchRequest] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const { isReadOnly } = useCurrentUser();
    const { isErrored, isFailed, request, reset } = useUpdateOrganization();
    useEffect(() => {
        if (sentOrganizationNamePatchRequest && (isErrored || isFailed)) {
            setSentOrganizationNamePatchRequest(false);
            setIsEditing(false);
            reset();
        }
    }, [isErrored, isFailed, reset, sentOrganizationNamePatchRequest]);
    const handleCancel = useCallback(() => {
        setIsEditing(false);
    }, []);
    const handleChange = useCallback((updatedTitle) => {
        setIsEditing(false);
        setSentOrganizationNamePatchRequest(true);
        request({
            name: updatedTitle,
            organizationId
        });
    }, [organizationId, request]);
    return (React.createElement("div", { className: 'organization-title' },
        React.createElement(Text, { className: 'title', editable: {
                editing: isEditing,
                icon: React.createElement("div", null),
                onCancel: handleCancel,
                onChange: handleChange,
                tooltip: false
            }, ellipsis: false }, organizationName),
        React.createElement(When, { condition: !isEditing && !isReadOnly },
            React.createElement(EditOutlined, { className: 'title-edit', onClick: () => {
                    setIsEditing(true);
                } }))));
};
